import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { FieldOperationSearchFieldName } from '../ui/field-operations.types';

export const FIELD_OPERATIONS_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [FieldOperationSearchFieldName.MtuDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.INSTALLED_BY,
    value: 2,
    types: [FieldOperationSearchFieldName.InstalledBy],
    hintText: SEARCH_HINTS.InstalledBy
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.METER_SERIAL_NUMBER,
    value: 3,
    types: [FieldOperationSearchFieldName.MeterSerialNumber],
    hintText: SEARCH_HINTS.MeterSerialNumber
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.METER_MODEL,
    value: 4,
    types: [FieldOperationSearchFieldName.MeterModel],
    hintText: SEARCH_HINTS.MeterModel
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SERVICE_LOCATION_NUMBER,
    value: 5,
    types: [FieldOperationSearchFieldName.ServiceLocationIds],
    hintText: SEARCH_HINTS.ServiceLocationNumber
  }
];

export const FIELD_OPERATIONS_DEFAULT_SEARCH_TYPE: SearchType = FIELD_OPERATIONS_SEARCH_TYPES[0];
